/** @format */
import { MarketCode } from '@mpb-com/feather/enums';

import { marketsWithTotalsExcludingTax } from '@toucan/client/global/market';

export const hasTotalsExcludingTax = (market: MarketCode) =>
    marketsWithTotalsExcludingTax.includes(market);
